import { useState } from 'react';
import { useDispatch } from 'react-redux';
import BreadCrumb from '../../components/template/BreadCrumb';
import Header from '../../components/template/Header';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import Spinner from '../../components/layout/Spinner';
import AddForm from '../../components/common/AddForm';
import { convertToFormData } from '../../shared/upload';
import api from '../../domain/api';
import { setAlert } from '../../store/actions/alert';
import {
  initialValues,
  inputFields,
  PAGE_TITLE,
  PAGE_SINGLE_TITLE,
  LINK_URL,
} from '../../shared/enums/employees_enum';
import {
  useUpdateEmployee,
  useSingleEmployee,
  useGetDropdownOptions,
} from '../../shared/hooks/UseEmployee';
// import { useSelectAllEmployee } from "../../shared/hooks/UseEmployee";

// Password update form with show/hide toggle
function PasswordUpdateForm({ submitPasswordForm }) {
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState('');
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password) return;
    await submitPasswordForm({ password });
  };
  return (
    <form onSubmit={handleSubmit}>
      <div className='form-group' style={{ position: 'relative' }}>
        <label htmlFor='password'>New Password</label>
        <input
          type={showPassword ? 'text' : 'password'}
          className='form-control'
          id='password'
          name='password'
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <span
          onClick={() => setShowPassword((v) => !v)}
          style={{
            position: 'absolute',
            right: 12,
            top: 38,
            cursor: 'pointer',
            zIndex: 2,
            color: '#888',
          }}
          title={showPassword ? 'Hide Password' : 'Show Password'}
        >
          <i className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
        </span>
      </div>
      <button type='submit' className='btn btn-primary mt-2'>
        Update Password
      </button>
    </form>
  );
}

const EditEmployee = ({ match }) => {
  let history = useHistory();
  const dispatch = useDispatch();
  const [single_data] = useSingleEmployee(match.params.id);
  const [updateData] = useUpdateEmployee();
  const { employee_loading, employee, edit_employee_loading } = single_data;
  const [featuredImage, setFeaturedImage] = useState(null);
  const [dropdownOptions] = useGetDropdownOptions();
  const [tabKey, setTabKey] = useState('general');

  // Remove password from inputFields for general info tab
  const generalInputFields = { ...inputFields };
  delete generalInputFields.password;

  const submitFormClicked = async (values) => {
    const data = await convertToFormData({ values, featuredImage });
    await updateData(employee._id, data);
    history.push(`/${LINK_URL}/${employee._id}/view`);
  };

  // Password update handler
  const submitPasswordForm = async (values) => {
    try {
      // Use the specific password update endpoint
      await api.put(`/employees/${employee._id}/password`, {
        password: values.password,
      });

      // Show success toast notification
      dispatch(setAlert('Password updated successfully!', 'success'));
      history.push(`/${LINK_URL}/${employee._id}/view`);
    } catch (error) {
      console.error('Password update failed:', error);
      dispatch(
        setAlert('Failed to update password. Please try again.', 'danger')
      );
    }
  };

  return (
    <div className='pace-done'>
      <div>
        <Header />
        <BreadCrumb
          title={`Edit ${PAGE_SINGLE_TITLE}`}
          mainLinkTitle={PAGE_TITLE}
          mainLinkUrl={LINK_URL}
          activeLink='Edit'
        />
      </div>
      <div className='container-fluid'>
        <div className='col-lg-12'>
          <div className='card'>
            {!employee_loading ? (
              employee && (
                <div>
                  <div className='card-header'>
                    <div>
                      <h4 className='card-title'>
                        {employee[Object.keys(inputFields)[0]]} -{' '}
                        <span>Edit</span>{' '}
                      </h4>
                      <p className='card-title-desc'>
                        <Link
                          to={`/${LINK_URL}`}
                          className='btn btn-soft-light'
                        >
                          <i className='fa fa-angle-left'></i> {PAGE_TITLE}
                        </Link>
                        <Link
                          to={`/${LINK_URL}/${employee._id}/view`}
                          className='btn btn-soft-light'
                        >
                          <i className='fa fa-eye'></i>
                        </Link>
                      </p>
                    </div>
                  </div>
                  {/* Custom Tabs UI */}
                  <div className='tabs-container mb-4'>
                    <div className='tabs-header'>
                      <button
                        className={`tab-btn ${
                          tabKey === 'general' ? 'active' : ''
                        }`}
                        onClick={() => setTabKey('general')}
                      >
                        <i
                          className='fa fa-user'
                          style={{ marginRight: '8px' }}
                        ></i>
                        General Info
                      </button>
                      <button
                        className={`tab-btn ${
                          tabKey === 'password' ? 'active' : ''
                        }`}
                        onClick={() => setTabKey('password')}
                      >
                        <i
                          className='fa fa-lock'
                          style={{ marginRight: '8px' }}
                        ></i>
                        Password Update
                      </button>
                    </div>
                  </div>
                  {/* Tab Content */}
                  <div className='tab-content'>
                    {tabKey === 'general' && (
                      <AddForm
                        data={employee}
                        edit={true}
                        featuredImage={featuredImage}
                        setFeaturedImage={setFeaturedImage}
                        submitForm={submitFormClicked}
                        inputFields={generalInputFields}
                        initialValues={initialValues}
                        dropdown_options={dropdownOptions}
                        loading={edit_employee_loading}
                      />
                    )}
                    {tabKey === 'password' && (
                      <div className='card-body'>
                        <PasswordUpdateForm
                          submitPasswordForm={submitPasswordForm}
                        />
                      </div>
                    )}
                  </div>
                  {/* Custom Tabs Styles */}
                  <style jsx>{`
                    .tabs-container {
                      background: white;
                      border-radius: 8px;
                      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                      overflow: hidden;
                    }
                    .tabs-header {
                      display: flex;
                      background: #f8f9fa;
                      border-bottom: 1px solid #e5e7eb;
                    }
                    .tab-btn {
                      display: flex;
                      align-items: center;
                      padding: 16px 24px;
                      border: none;
                      background: transparent;
                      color: #6b7280;
                      font-weight: 500;
                      font-size: 14px;
                      cursor: pointer;
                      transition: all 0.2s ease;
                      border-bottom: 3px solid transparent;
                      position: relative;
                      z-index: 1;
                    }
                    .tab-btn:hover {
                      background: #e5e7eb;
                      color: #374151;
                      transform: translateY(-1px);
                    }
                    .tab-btn.active {
                      background: white;
                      color: #4285f4;
                      border-bottom-color: #4285f4;
                      font-weight: 600;
                      box-shadow: 0 2px 4px rgba(66, 133, 244, 0.1);
                    }
                    .tab-content {
                      margin-top: 0;
                    }
                  `}</style>
                </div>
              )
            ) : (
              <div className='text-center'>
                <Spinner />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditEmployee;
